import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AdvancedDebugging } from 'src/app/utilities';
import { MASScheduleExtrasModel } from 'src/app/models/mas-schedules.model';
import { DashboardSchedulesFacade } from 'src/app/facades/dashboard-schedules.facade';

const OP_GO_TO_ROUTE = 'dashboard:DashboardComponent.goToRoute';

@Component({
	standalone: false,
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss'],
	providers: [DashboardSchedulesFacade],
})
export class DashboardComponent {
	protected readonly facade = inject(DashboardSchedulesFacade);
	private readonly router = inject(Router);
	private readonly advancedDebugging = new AdvancedDebugging();

	constructor() {
		this.facade.start();
	}

	goToRoute(schedule: MASScheduleExtrasModel): void {
		const commands = schedule.summary === 'YAS' ? ['yas', schedule.id] : ['parents', schedule.id];
		void this.router.navigate(commands).catch(error => {
			this.advancedDebugging.captureError(OP_GO_TO_ROUTE, error, {
				tags: { operation: OP_GO_TO_ROUTE, app: 'dashboard' },
				scheduleId: schedule.id,
				summary: schedule.summary,
			});
		});
	}
}
